import { useState, useCallback } from "react";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { getGeocoderResultProperties } from "../../../../components/Map/helpers";
import { useGetLocationFields } from "../../../../utils/hooks/useGetLocationFields";
import { fromLatLng } from "../../../../utils/helpers/geocode";

export const defaultCenter = { lat: 40.6974034, lng: -74.1197633 };
export const defaultZoom = 11;

export const useSearch = (changeMarker) => {
	const [search, setSearch] = useState("");

	const handleSelect = useCallback(
		async (value) => {
			const [result] = await geocodeByAddress(value);
			const marker = await getLatLng(result);

			const data = getGeocoderResultProperties(result);
			const address1 = data.address1;
			changeMarker(marker, data);
			setSearch(address1);
		},
		[setSearch, changeMarker],
	);

	return { search, setSearch, handleSelect };
};

export const useLocation = (form) => {
	const [marker, setMarker] = useState(null);
	const [zoom, setZoom] = useState(defaultZoom);
	const [center, setCenter] = useState(defaultCenter);
	const getFields = useGetLocationFields();

	const changeMarker = useCallback(
		async (marker, _data) => {
			setMarker(marker);
			setCenter(marker);
			setZoom(17);

			const response = await fromLatLng(marker);
			if (!response) {
				return;
			}
			
			const geocodeValues = _data ? _data : getGeocoderResultProperties(response);
			const fields = await getFields(response.address);
			const data = { ...geocodeValues , ...fields }
			form.setFieldValue("country", data?.country);
			form.setFieldValue("city", data?.city || "");
			form.setFieldValue("address1", data?.address1 || "");
			form.setFieldValue("postalCode", data?.postalCode || "");
			form.setFieldValue("state", data?.state || "");
			form.setFieldValue("address2", data?.address2 || "");
		},
		[getFields, form],
	);

	return {
		marker,
		setMarker,
		zoom,
		setZoom,
		center,
		setCenter,
		changeMarker,
	};
};
